import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-glow footer-glow-left" aria-hidden="true" />
      <div className="footer-glow footer-glow-right" aria-hidden="true" />

      <div className="footer-container">
        <div className="footer-brand">
          <span className="footer-badge">Domain Platform</span>
          <h2>DoHostingPay</h2>
          <p>
            Search, buy, and manage domains with a modern, clean, and premium
            user experience built for startups, creators, and growing brands.
          </p>
        </div>

        <div className="footer-links">
          <div className="footer-link-column">
            <h4>Company</h4>
            <a href="/about">About</a>
            <a href="/blog">Blog</a>
            <a href="/contact">Contact</a>
          </div>

          <div className="footer-link-column">
            <h4>Support</h4>
            <a href="/help">Help Center</a>
            <a href="/faq">FAQs</a>
            <a href="/terms">Terms</a>
          </div>

          <div className="footer-link-column">
            <h4>Domains</h4>
            <a href="/search">Search Domains</a>
            <a href="/pricing">Pricing</a>
            <a href="/dashboard">Dashboard</a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2026 DoHostingPay. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;